function isColorCardUploaded(card_pdf_path) {
    if (card_pdf_path?.includes("reservedarea.marchettopellami.com/docs/color_cards") && card_pdf_path?.endsWith(".pdf")) {
        return true
    } else {
        return false
    }

}

function isDocumentUploaded(document_pdf_path) {
    if (document_pdf_path?.includes("reservedarea.marchettopellami.com/docs/docs") && document_pdf_path?.endsWith(".pdf")) {
        return true
    } else {
        return false
    }

}

function isDatasheetUploaded(document_pdf_path) {
    if (document_pdf_path?.includes("reservedarea.marchettopellami.com/docs/technical_sheets") && document_pdf_path?.endsWith(".pdf")) {
        return true
    } else {
        return false
    }

}


export {
    isColorCardUploaded,
    isDocumentUploaded,
    isDatasheetUploaded
}